/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Business } from './Business';
import {
    BusinessFromJSON,
    BusinessFromJSONTyped,
    BusinessToJSON,
    BusinessToJSONTyped,
} from './Business';

/**
 * 
 * @export
 * @interface UpdateBulkBusinessActiveBody
 */
export interface UpdateBulkBusinessActiveBody {
    /**
     * 
     * @type {Array<Business>}
     * @memberof UpdateBulkBusinessActiveBody
     */
    businesses: Array<Business>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBulkBusinessActiveBody
     */
    isActive: boolean;
}

/**
 * Check if a given object implements the UpdateBulkBusinessActiveBody interface.
 */
export function instanceOfUpdateBulkBusinessActiveBody(value: object): value is UpdateBulkBusinessActiveBody {
    if (!('businesses' in value) || value['businesses'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function UpdateBulkBusinessActiveBodyFromJSON(json: any): UpdateBulkBusinessActiveBody {
    return UpdateBulkBusinessActiveBodyFromJSONTyped(json, false);
}

export function UpdateBulkBusinessActiveBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBulkBusinessActiveBody {
    if (json == null) {
        return json;
    }
    return {
        
        'businesses': ((json['businesses'] as Array<any>).map(BusinessFromJSON)),
        'isActive': json['isActive'],
    };
}

export function UpdateBulkBusinessActiveBodyToJSON(json: any): UpdateBulkBusinessActiveBody {
    return UpdateBulkBusinessActiveBodyToJSONTyped(json, false);
}

export function UpdateBulkBusinessActiveBodyToJSONTyped(value?: UpdateBulkBusinessActiveBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'businesses': ((value['businesses'] as Array<any>).map(BusinessToJSON)),
        'isActive': value['isActive'],
    };
}

